const colorShades = {
  white: '#fff',

  gray50: '#fafafa',
  gray100: '#f6f6f6',
  gray150: '#f3f3f3',
  gray200: '#eee',
  gray250: '#ddd',
  gray300: '#ccc',
  gray350: '#bbb',
  gray400: '#999',
  gray700: '#666',
  gray800: '#444',

  blue100: '#edfaff',
  blue200: '#f7f8ff',
  blue400: '#4555d0',
  blue800: '#10345E',

  red: '#cc4a1f',
};

const color = {
  activeText: colorShades.blue400,
  badgeText: colorShades.white,
  buttonText: colorShades.white,
  defaultText: colorShades.gray800,
  SECONDARY_TEXT: colorShades.gray400,
  DETAIL_TEXT: colorShades.gray700,
  eventDetailTitle: colorShades.white,
  ERROR: colorShades.red,
  lightText: colorShades.gray300,
  PLACEHOLDER: colorShades.gray350,
  LINK: colorShades.blue400,
  HIGHLIGHT: colorShades.gray100,

  lead: colorShades.gray700,

  INPUT: {
    BACKGROUND: colorShades.white,
    BORDER: colorShades.gray250,
    BORDER_ACTIVE: colorShades.blue400,
    HOVER: colorShades.gray100,
    ACTIVE: colorShades.blue400,
    ACTIVE_TEXT: colorShades.white,
  },
  inputShadow: colorShades.gray200,

  BTN_DISABLED: colorShades.gray400,
  BTN: {
    NEUTRAL: colorShades.blue400,
    DANGER: colorShades.red,
    DARK: colorShades.blue800,
  },
  BTN_SECONDARY: colorShades.white,
  BTN_TEXT_SECONDARY: colorShades.gray800,

  MASTHEAD_BACKGROUND: colorShades.white,
  MASTHEAD_BORDER: colorShades.gray200,

  ALERT_BANNER_PRIMARY: colorShades.white,

  badgeBackground: colorShades.blue400,
  contentBackground: colorShades.gray50,
  cardBackground: colorShades.white,
  categoryActiveBackground: colorShades.blue200,
  categoryBackground: colorShades.white,
  dateHeadingBackground: colorShades.gray50,
  detailHeaderBackground: colorShades.blue400,
  filterBackground: colorShades.white,
  MANAGE_SIDEBAR: colorShades.gray150,
  ACTIVE_MANAGE_EVENT_BACKGROUND: colorShades.gray50,
  HOVER_MANAGE_EVENT_BACKGROUND: colorShades.gray50,
  ACTIVE_MANAGE_EVENT_BORDER: colorShades.blue400,
  VIEW_BANNER: {
    BACKGROUND: colorShades.white,
    BOTTOM_BORDER: colorShades.gray150,
  },

  FORM_FOOTER: {
    BACKGROUND: colorShades.white,
  },

  iconDefault: colorShades.gray250,

  searchIcon: colorShades.gray400,
  SEARCH_BAR_BACKGROUND: colorShades.gray200,

  listDivider: colorShades.gray200,

  SPINNER: colorShades.blue400,
};

const FONT_FAMILY = {
  DEFAULT: 'Roboto, sans-serif'
};

const FONT_WEIGHT = {
  LIGHT: 300,
  REGULAR: 400,
  MEDIUM: 500,
  SEMI_BOLD: 600,
  BOLD: 700,
};

const FONT_SIZE = {
  XXS: '0.75rem',
  XS: '0.85rem',
  S: '0.9rem',
  M: '1rem',
  L: '1.1rem',
  XL: '1.15rem',
  XXL: '1.25rem',
};

const size = {
  width: {
    detailContentWidth: '80%',
    poster: '180px',
    sidebar: '270px',
  }
};

const BORDER_RADIUS = '9px';
const INPUT_MODAL_BOX_SHADOW = '0 7px 14px rgba(0, 0, 0, .03);';

const SPACING_BASE = 0.625;
const SPACING = {
  XXS: `${SPACING_BASE}rem`,
  XS: `${SPACING_BASE * 1.5}rem`,
  S: `${SPACING_BASE * 2}rem`,
  M: `${SPACING_BASE * 2.5}rem`,
  L: `${SPACING_BASE * 3}rem`,
  XL: `${SPACING_BASE * 4}rem`,
  XXL: `${SPACING_BASE * 5}rem`,
  XXXL: `${SPACING_BASE * 6}rem`,
};

const MEASUREMENT = {
  ALERT_BANNER: {
    HEIGHT: 75,
  },
  INPUT: {
    MODAL_PADDING: SPACING.XXS,
    MODAL_OFFSET: SPACING.XXS,
    MODAL_ITEM_PADDING: SPACING.XS,
  },
  BUTTON: {
    HEIGHT: {
      S: '40px',
      M: '55px'
    },
    MIN_WIDTH: '150px',
  },
  VIEW: {
    HEADER: '70px',
  },
  MASTHEAD: {
    HEIGHT: 65,
    LOGO_HEIGHT: '16px',
  },
  CATEGORY_NAV: {
    HEIGHT: 50,
  },
  MANAGE_EVENTS_SIDEBAR: {
    MIN_WIDTH: '300px',
    MAX_WIDTH: '400px',
  },
  PAGE: {
    MAX_WIDTH: '1024px',
  },
  EVENT_FORM: {
    FOOTER: {
      HEIGHT: '150px',
    },
    PADDING_BOTTOM: '180px',
    WIDTH: '500px',
  }
};

export default {
  BORDER_RADIUS,
  color,
  FONT_FAMILY,
  FONT_SIZE,
  FONT_WEIGHT,
  INPUT_MODAL_BOX_SHADOW,
  MEASUREMENT,
  size,
  SPACING,
};



// WEBPACK FOOTER //
// ./src/styles/common.js